<template>
  <div>
    <!-- 直播界面入口 -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'LiveEntry',
  data() {
    return {
      url: ''
    }
  },
  computed: {
    ...mapState(['userInfo', 'isLogin']),
    Aid() {
      return this.$route.query.Aid;
    }
  },
  created() {
    console.log(this.Aid)
    this.getLiveDocking();
  },
  methods: {
    getLiveDocking() {
      if(this.Aid) {
        this.$axios.get('/Api/Api/Web/Live/LiveDocking?artId=' + this.Aid).then(res => {
          if (res.RetCode == '10000') {
            location.href = res.Data;
          } else {
            this.$toast(res.RetMsg);
          }
        })
      } else {
        this.$toast('数据获取异常，请联系管理员！');
      }
    }
    // getLiveUrl() {
    //   if(this.userInfo.Id && this.uri) {
    //     this.$axios.post('/Api/Api/Web/Live/LiveDockingByChannel', {
    //       CustomerID: this.userInfo.Id,
    //       Url: this.url
    //     }).then(res => {
    //       if (res.RetCode == '10000') {
    //         // location.href = res.Data;
    //       } else {
    //         this.$toast(res.RetMsg);
    //       }
    //     })
    //   } else {
    //     this.$toast('数据获取异常，请联系管理员！');
    //   }
      
    // }
  }
}
</script>